/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-return */
// 新版本首页实验版本：http://wiki.cheyaoshicorp.com/pages/viewpage.action?pageId=165530353
import { namespace } from 'vuex-class';
import { Component, Mixins } from 'vue-property-decorator';

import { PullRefresh } from 'vant';
import { RouterV2Enum } from '@/router/router-names';
import HomeBottomBar from '@/components/home-bottom-bar';
import isPrerendering from '@/shared/utils/isPrerendering';
import AdvertDialog from '@/mixins/advert-dialog';
import AboutPanel from '@/components/about-panel';
import AdvBanners from '@/components/adv-components/adv-banners';
import AdvProductList from '@/components/adv-components/adv-product-list';
import { RightsBannerType } from '@/views_v2/my-profile/types';
import {
  BannerClickActionEnums,
  HomeThemeEnums, getHomeThemeBodyConfig,
} from '@/shared/utils/pageTheme';
import FinanceBusiness from '@/mixins/finance-business';
import { ubtSendError } from '@/shared/utils/ubt';
import store from '@/store';
import platform from '@/shared/utils/platform';
import MessageNoticeBar from '@/pages/home/components/MessageNoticeBar/index.vue';
import PocketMoneyCard from '@/pages/home/components/PocketMoneyCard/index.vue';
import { currentPage } from './currentPage';

import RewardingActivity from '../../components/rewarding-activity';
import RiskStatement from '../../components/risk-statement';
import AppQualityNewFinanceCard from '../../components/finance-quality-card';
import ThemeBanner from '../../components/theme-banner';

// 提额降息专区
const IncreaseCreditZone = () => import(
  /* webpackChunkName: "increase-credit-zone" */'../../components/increase-credit-zone'
) as any;

// 快速提现卡片组件 - 异步导入
const QuickWithdrawCard = () => import(
  /* webpackChunkName: "quick-withdraw-card" */'@/components/quick-withdraw-card/index.vue'
) as any;

const HomeStore = namespace('home');
const _isPrerendering = isPrerendering();
const style: Dictionary = require('./index.module.scss');

@Component
export default class QualityContent extends Mixins(
  AdvertDialog,
  FinanceBusiness,
) {
  @HomeStore.State notice!: string |undefined;

  @HomeStore.Action getCreditData!: (shouldRefresh?: boolean) => Promise<void>;

  @HomeStore.State homeThemeType!: HomeThemeEnums | null;

  private visible = false

  private isRefresh = false

  private timeId: NodeJS.Timeout | null = null

  private bannerList: RightsBannerType[] = [];

  // 检查快速提现卡片弹窗是否显示并关闭
  public async checkAndCloseQuickWithdrawCard(): Promise<boolean> {
    const quickWithdrawCard = this.$refs.quickWithdrawCardRef as {
      closePopup?: () => Promise<boolean>;
    } | undefined;
    if (quickWithdrawCard && typeof quickWithdrawCard.closePopup === 'function') {
      const hasClosed = await quickWithdrawCard.closePopup();
      return hasClosed;
    }
    return false; // 没有弹窗或未关闭
  }

  // 路由判断
  private get currentRoutePath() {
    return [
      `${RouterV2Enum.qualityHomePage}`,
      `${RouterV2Enum.qualityHomeWithAdvert}`,
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    ].includes(this.$route.path);
  }

  // 是否有滑动
  private get isTouchMoved() {
    return currentPage();
  }

  // 动画展示条件
  private get isDisplayAnimation() {
    const { creditStatus } = this.creditData || {};

    if (this.currentRoutePath) {
      return false;
    }

    return (!creditStatus) && (this.isTouchMoved);
  }

  private created() {
    if (!_isPrerendering) {
      window.scrollTo(0, 1);
      this.timeId = setTimeout(() => {
        this.visible = true;
      }, 100);
    }
  }


  private onThemeBannerClick(action?: string) {
    if (action === BannerClickActionEnums.JUMP_TO_APPLY_PRODUCT) {
      this.onApplyProduct('finance_quality_promote_loan');
    } else if (action === BannerClickActionEnums.JUMP_TO_CREDIT) {
      this.onApplyCredit('finance_quality_promote_credit');
    } else {
      ubtSendError('ThemeBannerClick Invalid Action');
    }
  }

  private render() {
    const themeBannerConfig = getHomeThemeBodyConfig(this.homeThemeType, this.$route.name);
    const { isValidTheme, bgTransitionStyle, clickAction } = themeBannerConfig;

    return (
      <div class={style.newHomePage}>
        <PullRefresh
          v-model={this.isRefresh}
          onRefresh={this.onRefresh.bind(this)}
          disabled={true}
        >
          <div
            class={[
              style.homePage,
              !this.notice && style.withSlogan,
              style.homePageNew,
              isValidTheme && style.customeThemeBox,
            ]}
            style={[isValidTheme && bgTransitionStyle]}
          >
            <ThemeBanner
              themeConfig={themeBannerConfig}
              onThemeBannerClick={() => this.onThemeBannerClick(clickAction)}
            />
            {this.isDisplayAnimation && (
              <div class={[style.opacityBg, this.visible && style.transFormLate]}></div>
            )}
            {this.creditData && (
              <MessageNoticeBar
                userCreditData={this.creditData}
                className={'homeMessageNoticeBarWrapper'}
              />
            )}
            {/** 新版金融卡片 */}
            <AppQualityNewFinanceCard
              userCreditData={this.creditData}
            />
            {this.creditData && (
              <PocketMoneyCard
                userCreditData={this.creditData}
              />
            )}

            {this.isDisplayAnimation ? this.unlicensedRender() : this.creditGrantedRender()}

            {!store.state.base.isHybridAppMode ? <div class={style.safeArea}/> : ''}
          </div>
        </PullRefresh>

        {!_isPrerendering && (
          <HomeBottomBar currentPage={'qualityHomePage'}/>
        )}

        {/* 快速提现卡片组件 - 完全内聚，无需外部事件处理 */}
        {this.creditData && (
          <QuickWithdrawCard
            ref="quickWithdrawCardRef"
            userCreditData={this.creditData}
          />
        )}
      </div>
    );
  }

  // 未授信
  private unlicensedRender() {
    return (
      <div class={[
        style.homeParty,
        this.visible && style.transUp,
      ]}>
        {this.renderContent()}
      </div>
    );
  }

  // 展示 banner
  private renderBannerAdv() {
    if (platform.isWechatMini) {
      return null;
    }
    return <AdvBanners/>;
  }

  // 已授信
  private creditGrantedRender() {
    return this.renderContent();
  }

  private renderContent() {
    // 天降红包优先级较高
    return !_isPrerendering && [
      !platform.isWechatMini && <AdvProductList />,
      <IncreaseCreditZone />,
      this.renderBannerAdv(),
      <RewardingActivity />,
      <AboutPanel currentHomePage={'qualityHome'}/>,
      <RiskStatement />,
    ];
  }

  private beforeDestroy() {
    if (this.timeId) {
      clearTimeout(this.timeId);
    }
  }

  // 下拉刷新
  private onRefresh() {
    this.getCreditData().then(() => {
      this.isRefresh = false;
    });
  }
}
